module.exports = __webpack_public_path__ + "media/newstyle/images/stars_sprint-fd5547115ffe2f1949138c83dd8bc67d.svg";